import { render, staticRenderFns } from "./FlowEditorInitArea.vue?vue&type=template&id=7f9e9436&"
import script from "./FlowEditorInitArea.vue?vue&type=script&lang=js&"
export * from "./FlowEditorInitArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports